const input_qty = document.querySelector('.input-wrapper .qty-label'),
      quantityContainer = document.querySelector('quantity-input'),
      submitBtn = document.querySelector('.product-form__submit');

document.querySelectorAll('.custom-qty-wrapper .qty-label').forEach(function(target){
  if(hasClass(target, 'active')){
    let custom_qty = target.getAttribute('data-qty');
    if(custom_qty != '') {
      quantityContainer.querySelector(`
        .quantity__input
      `).value = custom_qty;      
    }    
  }
  target.addEventListener('click', function(){
    document.querySelectorAll('.custom-qty-wrapper .qty-label').forEach(function(el){
      el.classList.remove('active');
    });
    target.classList.add('active');
    submitBtn.disabled = false;
    let custom_qty = target.getAttribute('data-qty');
    if(custom_qty != '') {
      quantityContainer.querySelector(`
        .quantity__input
      `).value = custom_qty;      
    }
  });
});


input_qty.addEventListener('click', (e) => {
  let custom_qty = input_qty.getAttribute('data-qty');
  if(custom_qty == '') {
    submitBtn.disabled = true;
  }
});

input_qty.addEventListener('keyup', (e) => {
  const inputedValue = (e.target.value).replace(',', '.'),
        quantity = parseFloat(inputedValue) / 0.5;
  if((quantity < 1) || (parseFloat(inputedValue) % 0.5 != 0)) {
    submitBtn.disabled = true;
    input_qty.setAttribute('data-qty', '');
    return;
  }
  submitBtn.disabled = false;
  input_qty.setAttribute('data-qty', quantity);
  quantityContainer.querySelector(`
    .quantity__input
  `).value = quantity;
});

function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

// window.addEventListener('load', () => {
//   setTimeout(() => {
//       const popups = document.querySelector('#shopTheLook');
//       document.querySelector('body').addEventListener('click', (e) => {
//         const popupStatus = popups.style.position == 'fixed' ? false : true;
//         if(!e.target.closest('#shopTheLook') && true && e.target.id != 'shopthelook') {
//           popups.querySelector('.close').click();
//         }
//       });
//   },1500)
// });
